import { Id, isSuccess } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { filterService } from "./filter";

interface Options {
	filterId: Id | null;
	onNotFound?: () => void;
}

export const useFilterQuery = ({ filterId, onNotFound }: Options) => {
	return useQuery({
		enabled: filterId != null,
		queryKey: filterService.showKey(String(filterId)),
		queryFn: async () => {
			if (!filterId) return null;
			const response = await filterService.show(filterId);
			if (isSuccess(response)) {
				return response.data.data;
			} else if (response instanceof AxiosError && response.response?.status === 404) {
				onNotFound?.();
			}
			return null;
		},
	});
};
